import React, { useEffect, useRef } from "react"
import { Link } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
    const particlesRef = useRef(null)

    return (
        <>
            <div className="height-emulator fl-wrap"></div>
            <footer className="main-footer fixed-footer">
                <div className="footer-inner fl-wrap">
                    <div className="container">
                        <div ref={particlesRef} className="partcile-dec" data-parcount="90"></div>
                        <div className="row">
                            <div className="col-md-2">
                                <div className="footer-title fl-wrap">
                                    <span>PragICTS</span>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="footer-header footer-header-contacts fl-wrap"><span>01.</span> Contact Us</div>
                                <div className="footer-box fl-wrap">
                                    <div className="footer-contacts fl-wrap">
                                        <p>General / Marketing</p>
                                        <ul>
                                            <li><i className="fal fa-phone"></i><span>Phone :</span><a href="tel:0094742713262">+94 74 271 3262</a></li>
                                            <li><i className="fal fa-envelope"></i><span>Email :</span><a href="mailto:info@pragicts.com">info@pragicts.com</a></li>
                                        </ul>
                                    </div>
                                    <div className="footer-contacts fl-wrap">
                                        <p>Support</p>
                                        <ul>
                                            <li><i className="fal fa-phone"></i><span>Phone :</span><a href="tel:0094742703262">+94 74 270 3262</a></li>
                                            <li><i className="fal fa-envelope"></i><span>Email :</span><a href="mailto:support@pragicts.com">support@pragicts.com</a></li>
                                        </ul>
                                    </div>
                                    <div className="footer-contacts fl-wrap">
                                        <p>Escalations</p>
                                        <ul>
                                            <li><i className="fal fa-phone"></i><span>Phone :</span><a href="tel:0094704598983">+94 70 459 8983</a></li>
                                            <li><i className="fal fa-envelope"></i><span>Email :</span><a href="mailto:escalations@pragicts.com">escalations@pragicts.com</a></li>
                                        </ul>
                                    </div>
                                    <div className="footer-contacts fl-wrap">
                                        <ul>
                                        <StaticImage src='../images/qr-code.png'  ></StaticImage>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="footer-header footer-header-contacts fl-wrap"><span>02.</span>Verticals</div>
                                <div className="footer-box fl-wrap">
                                    <div className="footer-contacts fl-wrap">
                                        <p>Services</p>
                                        <ul>
                                        <li><i className="fal fa-arrow-right"></i><a href="https://pragicts.com">Pragicts</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://softwaredevelopment.pragicts.com/">Software</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://itops.pragicts.com/">Itops</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://cloudops.pragicts.com/">Cloudops</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://cybersecops.pragicts.com/">Cybersecurityops</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://automation.pragicts.com/">Automation</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://digitaloutreach.pragicts.com/">Digitaloutreach</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://ai.pragicts.com/">Ai</a></li>
                                        </ul>
                                    </div>
                                    <div className="footer-contacts fl-wrap">
                                        <p>Solutions</p>
                                        <ul >
                                        <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://ecommerce.pragicts.com/">Ecommerce</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://sentinel.pragicts.com/">Sentinel</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://smiley.pragicts.com/">Smiley</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://pulse.pragicts.com/">Pulse</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://pay.pragicts.com/">Pay</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://cognizant.pragicts.com/">Cognizant</a></li>

                {/* <li><a rel="noreferrer noopener" href="https://www.linkedin.com/company/pragicts/" target="_blank"><i aria-label='Linkedin' className="fab fa-linkedin"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.facebook.com/pragicts.ltd" target="_blank"><i aria-label='Facebook' className="fab fa-facebook-f"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.instagram.com/pragicts/" target="_blank"><i aria-label='Instagram' className="fab fa-instagram"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://twitter.com/pragictsltd" target="_blank"><i aria-label='Twitter' className="fab fa-twitter"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.pinterest.com/pragicts" target="_blank"><i aria-label='Pinterest' className="fab fa-pinterest"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.youtube.com/channel/UCNYbr4DHBPqeXslkZ6hRruQ" target="_blank"><i aria-label='YouTube' className="fab fa-youtube"></i></a></li>*/}
                </ul>

             


                                    </div>
                                </div>
                            </div>
                            
                    
                            <div className="col-md-3">
                                <div className="footer-header footer-header-contacts fl-wrap"><span>03.</span>Other Links</div>
                                <div className="footer-box fl-wrap">
                                    <div className="footer-contacts fl-wrap">
                                       
                                        <ul>
                                        <li><i className="fal fa-arrow-right"></i><a href="https://perspectives.pragicts.com/">Our Perspectives</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://ourshare.pragicts.com/">OurShare</a></li>
                                            <li><i className="fal fa-arrow-right"></i><a target="_blank" href="https://projects.pragicts.com/?category=automation">Projects</a></li>
                                 
                                        </ul>
                                    </div>
                                
                                </div>
                                </div>
                                 

                        
                           
                        </div>
                        <div className="row" style={{ display: 'none' }}>
                            <div className="footer-socilal fl-wrap">
                                <ul >
                                    <li><a href="https://www.linkedin.com/company/pragicts/" target="_blank"><i aria-label='Linkedin' className="fab fa-linkedin"></i></a></li>
                                    <li><a href="https://www.facebook.com/pragicts.ltd" target="_blank"><i aria-label='Facebook' className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://www.instagram.com/pragicts/" target="_blank"><i aria-label='Instagram' className="fab fa-instagram"></i></a></li>
                                    <li><a href="https://twitter.com/pragictsltd" target="_blank"><i aria-label='Twitter' className="fab fa-twitter"></i></a></li>
                                    <li><a href="https://www.pinterest.com/pragicts" target="_blank"><i aria-label='Pinterest' className="fab fa-pinterest"></i></a></li>
                                    <li><a href="https://www.youtube.com/channel/UCNYbr4DHBPqeXslkZ6hRruQ" target="_blank"><i aria-label='YouTube' className="fab fa-youtube"></i></a></li>
                                    <li><a href="https://pragicts.blogspot.com/" target="_blank"><i aria-label='YouTube' className="fab fa-blogger"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="subfooter fl-wrap">
                    <div className="container">
                        <div className="policy-box">
                        <div>&#169; PragICTS   <span id="autodate"></span>  |  All rights reserved | <a  href="/gdpr"  style={{ color: 'red' }}>GDPR</a></div>
                        </div>
                        <a href="#" className="to-top color-bg"><i className="fal fa-angle-up"></i><span></span></a>
                    </div>
                </div>
            </footer>
            <Link className="contact-btn color-bg" to="/contact-us"><i className="fal fa-envelope"></i><span>Get in Touch</span></Link>
        </>
    )
}

export default Footer
